import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { ErrorBoundary } from './components/ErrorBoundary.jsx'
import { initSentry } from './utils/sentry.js'
import { migrateLocalStorageKeys } from './utils/migrate.js'
import { trackVisit } from './utils/analytics.js'
import { checkAndPruneIfNeeded } from './utils/quota.js'
import './index.css'

// Init Sentry first so any error in the boot steps below gets captured.
// No-op when VITE_SENTRY_DSN is unset (local dev without the env var).
initSentry()

// Rename agora_* localStorage keys to verdant_* on first boot after the
// project rename. Safe to run on every boot (idempotent).
migrateLocalStorageKeys()

// First funnel event. One-shot per browser session.
trackVisit()

// localStorage quota guard. Async; never blocks render.
checkAndPruneIfNeeded()

// Plausible loads only when VITE_PLAUSIBLE_DOMAIN is set, so the env var
// stays unset until a Plausible site is created. Vercel Analytics ships
// in App.jsx and lights up automatically on Vercel hosting.
const plausibleDomain = import.meta.env.VITE_PLAUSIBLE_DOMAIN
if (plausibleDomain) {
  const s = document.createElement('script')
  s.defer = true
  s.dataset.domain = plausibleDomain
  s.src = 'https://plausible.io/js/script.js'
  document.head.appendChild(s)
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    {/* Opt into the v7 behaviors now to silence the deprecation warnings
        React Router 6 prints on every load. Both flags are the eventual
        defaults in v7 and behaviorally fine for our app. */}
    <ErrorBoundary>
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
)
